import Configs from "../../vendorConfigs/Configs";
import GameModel from "../../../core/src/model/GameModel";
import { IRequestBuilder } from "../../../core/src/server/requests/RequestBuilder";

export default class SkipFreeGamesRequest implements IRequestBuilder {
    get method() {
        return "GET";
    }
  
    get path() {
        return Configs.game.clientConfig.gameServerApi + "/freespins";
    }
  
    get requestData() {
        return {
            sid: GameModel.sessionID,
            action: "skip"
        };
    }
}